module.exports = __webpack_public_path__ + "static/graph-illustration-88352525e44f4f9b3ace3aebd63f1920.png";